import { render } from "./HomeWrapper.vue?vue&type=template&id=e06bef1e&scoped=true"
import script from "./HomeWrapper.vue?vue&type=script&lang=js"
export * from "./HomeWrapper.vue?vue&type=script&lang=js"

import "./HomeWrapper.vue?vue&type=style&index=0&id=e06bef1e&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e06bef1e"]])

export default __exports__